

export const mdiIcons:string[] = require("./mdi-5.3.45.json");